import React, { useState } from 'react';
import styled from 'styled-components';

import { Throbber } from '@lt/components';
import type { Values } from '@lt/widget/components/Cigarette/context';
import type {
  TrackSubmitParams,
  FieldType,
} from '@lt/widget/components/Cigarette/types';

import SearchTypeTabs from 'src/components/SearchTypeTabs';
import SearchWidgetInitializer from 'src/components/SearchWidgetInitializer';
import LazyCigarette from 'src/components/Cigarette/components/LazyCigarette';

import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';
import type { SearchType } from 'src/types/search';

import Logo from '../HeaderLogo';
import Menu from '../HeaderMenu';

interface HeaderSearchFormProps {
  initWidget: boolean;
  isNew: boolean;
  cigaretteValues?: Values;
  pageSearchType: SearchType;
  isMobile?: boolean;
  availableSearchTypes?: SearchType[];
  inPreview?: boolean;
  submitCigarette?: ({ values, searchType }: TrackSubmitParams) => void;
  initialOpenedField?: FieldType;
}

const HeaderSearchForm = ({
  initWidget,
  isNew,
  cigaretteValues,
  pageSearchType,
  isMobile,
  availableSearchTypes,
  inPreview = false,
  submitCigarette,
  initialOpenedField,
}: HeaderSearchFormProps) => {
  const oldCigaInitializer = initWidget ? (
    <SearchWidgetInitializer />
  ) : (
    <Throbber size={30} />
  );
  const [searchType, setSearchType] = useState<SearchType>(
    pageSearchType ||
      (availableSearchTypes &&
        availableSearchTypes.length >= 1 &&
        availableSearchTypes[0]) ||
      'package',
  );

  const isNewCigarette = getIsFeatureHasAnOption(
    isMobile ? 'cigarette_type_mobile' : 'cigarette_type',
    'new',
  );

  const SearchTabs = (
    <StyledTabs
      selectedTab={searchType}
      setSelectedTab={setSearchType}
      variant={{
        mobile: isMobile || false,
        wl: false,
        page: 'SEARCH',
        collapsed: false,
      }}
    />
  );

  return (
    <>
      <MenuWrapper $isNewCigarette={isNewCigarette} $isMobile={isMobile}>
        <StyledLogo inWidget />
        {!isMobile ? SearchTabs : null}
        <StyledMenu isCollapsed={false} />
      </MenuWrapper>

      {isNew ? (
        <CigaretteBlock>
          {isMobile ? SearchTabs : null}
          <LazyCigarette
            isMobile={isMobile}
            searchType={searchType}
            cigaretteValues={cigaretteValues}
            trackSubmit={submitCigarette}
            allowPreview={!inPreview}
            inHeader
            initialOpenedField={initialOpenedField}
          />
        </CigaretteBlock>
      ) : (
        oldCigaInitializer
      )}
    </>
  );
};

const StyledTabs = styled(SearchTypeTabs)`
  align-self: flex-end;
  ${({ variant }) =>
    variant.mobile ? '  margin-bottom: 8px;' : '  margin-left: 14px;'}
`;

const MenuWrapper = styled.div<{
  $isNewCigarette?: boolean;
  $isMobile?: boolean;
}>`
  display: flex;
  align-items: center;
  ${({ $isMobile }) => {
    if ($isMobile) {
      return 'height: 55px';
    }
    return 'height: 48px;';
  }}
`;

const StyledMenu = styled(Menu)`
  margin-left: auto;
  z-index: 4;
`;

const StyledLogo = styled(Logo)`
  padding-left: 3px;
`;

const CigaretteBlock = styled.div``;

export default HeaderSearchForm;
